import { Injectable } from "@angular/core";
import { LayerAPIService } from "../../shared/services/API/LayersAPI.service";

@Injectable({
  providedIn: "root",
})
export class LayerService{
  public isInternalLayersVisible: boolean = false;
  public isExternalLayersVisible: boolean = false;
  public isMapLayersVisible: boolean = false;

  public isInternalLayersButtonDisabled: boolean = false;
  public isExternalLayersButtonDisabled: boolean = true;
  public isMapLayersButtonDisabled: boolean = true;

    // capas = new Array<LayerDTO>();
  
    // private capas$: Subject<LayerDTO[]> = new Subject<LayerDTO[]>();
    // isActiveLayer: boolean = false;
    // activeLayer: LayerDTO = {name: "layer-locationsGeneral", checked: this.isActiveLayer, idLayerType: 1, isVisible: this.isActiveLayer, categoryId: null, atributeDisplay: null, icon: null, id: null, layerType: null, atributes: null, itWorksAsVirtualLocation: false};
    // isFilterLayer: boolean = false;
    // filterLayer: LayerDTO = {name: "filter-layer-locationsGeneral", checked: this.isFilterLayer, idLayerType: 1, isVisible: this.isFilterLayer, categoryId: null, atributeDisplay: null, icon: null, id: null, layerType: null, atributes: null, itWorksAsVirtualLocation: false};
  
    // suscription_GetLayerDataByNameGeoJSON: Subscription;
  
    constructor(
      private layerService : LayerAPIService
    ) {
    }

    closeAllLayers() {
      this.isInternalLayersVisible = false;
      this.isExternalLayersVisible = false;
      this.isMapLayersVisible = false;
    }

  GetListLayers(idLayerSource) {
    return this.layerService.GetListLayers(idLayerSource);
  }

  GetLayerDataByNameGeoJSON(name, atributeDisplay) {
    return this.layerService.GetLayerDataByNameGeoJSON(name, atributeDisplay);
  }
}
